import { sanitizeUrl } from '../utils/sanitize';

const INVALID_VALUES = ['null', 'undefined', ''];

class DocumentOpenManager {
  constructor({
    apiBase = process.env.REACT_APP_API_URL || '',
    openWindow = (url, target) => window.open(url, target)
  } = {}) {
    this.apiBase = apiBase;
    this.openWindow = openWindow;
  }

  resolveUrl(source) {
    const rawUrl = this.extractUrl(source);
    if (!this.isUsableUrl(rawUrl)) {
      return '';
    }

    return sanitizeUrl(this.buildUrl(rawUrl));
  }

  open(source) {
    const url = this.resolveUrl(source);
    if (!url) {
      return false;
    }

    const openedWindow = this.openWindow(url, '_blank');
    if (openedWindow) {
      openedWindow.opener = null;
    }

    return true;
  }

  extractUrl(source) {
    if (source == null) {
      return '';
    }

    if (typeof source === 'string' || typeof source === 'number') {
      return String(source);
    }

    if (typeof source !== 'object') {
      return '';
    }

    const directUrl = Object.prototype.hasOwnProperty.call(source, 'url')
      ? source.url == null
        ? ''
        : source.url
      : '';

    if (this.isUsableUrl(directUrl)) {
      return directUrl;
    }

    if (source.document && source.document !== source) {
      return this.extractUrl(source.document);
    }

    return '';
  }

  isUsableUrl(value) {
    if (value == null) {
      return false;
    }

    const trimmed = String(value).trim();
    if (INVALID_VALUES.includes(trimmed.toLowerCase())) {
      return false;
    }

    const pathname = this.pathnameOf(trimmed);
    if (pathname === '/null' || pathname === '/undefined') {
      return false;
    }

    return true;
  }

  buildUrl(rawUrl) {
    const trimmed = String(rawUrl).trim();
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }

    const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    const base = String(this.apiBase || '').replace(/\/$/, '');
    return `${base}${path}`;
  }

  pathnameOf(value) {
    if (value.startsWith('/')) {
      return value.replace(/\/+$/, '') || '/';
    }

    try {
      return new URL(value, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (error) {
      return value;
    }
  }
}

export default DocumentOpenManager;
